import {getActiveBranchId} from '../utils/branch';
/* eslint-disable @typescript-eslint/no-unused-vars, react-hooks/exhaustive-deps */
import React,{useState,useEffect,useCallback} from 'react';
import Layout from '../components/layout/Layout';
import {useNavigate} from 'react-router-dom';
import StatCard from '../components/common/StatCard';
import SlidePanel from '../components/common/SlidePanel';
import DataTable from '../components/common/DataTable';
import Badge from '../components/common/Badge';
import {Input,Select} from '../components/common/FormField';
import api from '../services/api';
import PatientSearchInput from '../components/patient/PatientSearchInput';
import {fmtDate,fmtDateTime,safeArray} from '../utils/helpers';
import {openTemplatedPrintWindow} from '../utils/printUtils';
import AdmissionSearchInput from '../components/common/AdmissionSearchInput';

const SAMPLE_TYPES=['BLOOD','URINE','STOOL','SPUTUM','TISSUE','SWAB','CSF'];
const CONTAINER_TYPES=['EDTA (Purple)','SST (Gold)','Citrate (Blue)','Plain (Red)','Urine Cup','Swab','Other'];
const PRIORITIES=['ROUTINE','URGENT','STAT'];
const DEPARTMENTS=['Hematology','Biochemistry','Microbiology','Serology','Histopathology','Cytology','Immunology'];
const REJECTION_REASONS=['HEMOLYZED','INSUFFICIENT','WRONG_CONTAINER','DAMAGED','CLOTTED'];
const ANTIBIOTICS=['Amoxicillin','Ampicillin','Ciprofloxacin','Levofloxacin','Ceftriaxone','Cefuroxime','Meropenem','Imipenem','Piperacillin-Tazobactam','Gentamicin','Amikacin','Vancomycin','Linezolid','Metronidazole','Trimethoprim-Sulfamethoxazole'];
const SENSITIVITY=['SENSITIVE','RESISTANT','INTERMEDIATE'];

const STATUS_COLOR:Record<string,string>={ORDERED:'bg-blue-100 text-[#02357A]',SAMPLE_COLLECTED:'bg-teal-100 text-teal-700',PROCESSING:'bg-amber-100 text-amber-700',TECH_VERIFIED:'bg-indigo-100 text-indigo-700',COMPLETED:'bg-green-100 text-green-700',VERIFIED:'bg-purple-100 text-purple-700',CANCELLED:'bg-red-100 text-red-700'};

export default function LaboratoryPage(){
  const nav=useNavigate();
  const [tab,setTab]=useState<string>('orders');
  const [stats,setStats]=useState<any>({});
  const [msg,setMsg]=useState('');
  const [saving,setSaving]=useState(false);
  const [loading,setLoading]=useState(false);

  // Orders
  const [orders,setOrders]=useState<any[]>([]);
  const [orderTotal,setOrderTotal]=useState(0);
  const [filterStatus,setFilterStatus]=useState('');
  const [showOrderForm,setShowOrderForm]=useState(false);
  const [orderPatient,setOrderPatient]=useState<any>(null);
  const [orderDoctors,setOrderDoctors]=useState<any[]>([]);
  const [labTests,setLabTests]=useState<any[]>([]);
  const [labPanels,setLabPanels]=useState<any[]>([]);
  const [selectedTests,setSelectedTests]=useState<string[]>([]);
  const [selectedPanels,setSelectedPanels]=useState<string[]>([]);
  const [orderForm,setOrderForm]=useState<any>({patientId:'',doctorId:'',priority:'ROUTINE',clinicalNotes:'',fastingRequired:false,admissionId:'',visitId:'',
      sampleBarcode:'',
      tubeType:'',
      sampleVolume:'',
      fasting:false,
      collectionNotes:'',
      rejectionReason:'',
      referenceLabId:'',
      outsourcedLab:false,
      outsourcedAt:'',
      reportedBy:'',
      verifiedBy:'',
      autoValidated:false,
      criticalValueAlerted:false,
      criticalAlertedTo:'',
      criticalAlertedAt:'',
      cultureId:'',
      sampleId:'',
      gramStainResult:'',
      grossFindings:'',
      microscopicFindings:'',
      histoReportedBy:'',
      microbiologyComments:'',
      sensitivity:'',
      loinc:'',
      snomed:''
    });

  // Selected order detail
  const [selectedOrder,setSelectedOrder]=useState<any>(null);
  const [showOrderDetail,setShowOrderDetail]=useState(false);
  const [orderResults,setOrderResults]=useState<any[]>([]);

  // Tests master
  const [showTestForm,setShowTestForm]=useState(false);
  const [editTestId,setEditTestId]=useState<string|null>(null);
  const [testForm,setTestForm]=useState<any>({testName:'',testCode:'',testCategory:'Biochemistry',department:'Biochemistry',sampleType:'Blood',unit:'',normalRange:'',methodology:'',turnAroundTimeHours:'24',price:'',gstPercentage:'18',
      consultationId:'',
      admissionId:'',
      sampleCollectedBy:'',
      sampleBarcode:'',
      reportGeneratedAt:'',
      requestedBy:''
    });

  // Panels
  const [showPanelForm,setShowPanelForm]=useState(false);
  const [panelForm,setPanelForm]=useState<any>({panelCode:'',panelName:'',department:'Biochemistry',description:'',price:'',turnAroundTimeHours:'24',tests:[] as string[]});

  // Sample Collection
  const [pendingOrders,setPendingOrders]=useState<any[]>([]);
  const [collectForm,setCollectForm]=useState<any>({requestId:'',patientId:'',sampleType:'BLOOD',containerType:'EDTA (Purple)',collectionLocation:'OPD',barcode:''});
  const [showCollect,setShowCollect]=useState(false);
  const [sampleStatus,setSampleStatus]=useState<any>({id:'',status:'',rejectionReason:''});
  const [showSampleStatus,setShowSampleStatus]=useState(false);

  // Result Entry
  const [resultOrder,setResultOrder]=useState<any>(null);
  const [resultParams,setResultParams]=useState<any[]>([]);
  const [showResultEntry,setShowResultEntry]=useState(false);
  const [interpretation,setInterpretation]=useState('');

  // Culture & Sensitivity
  const [cultureOrder,setCultureOrder]=useState<any>(null);
  const [cultureForm,setCultureForm]=useState<any>({requestId:'',specimenType:'Blood',organismIdentified:'',growthStatus:'NO_GROWTH',colonyCount:'',gramStain:'',finalReport:''});
  const [abxRows,setAbxRows]=useState<any[]>([{antibiotic:'Amoxicillin',result:'SENSITIVE',mic:''}]);
  const [showCulture,setShowCulture]=useState(false);

  // Reports
  const [reportDates,setRD]=useState<any>({from:new Date(Date.now()-30*86400000).toISOString().split('T')[0],to:new Date().toISOString().split('T')[0]});
  const [reportData,setReportData]=useState<any>(null);

  const notify=(m:string)=>{setMsg(m);setTimeout(()=>setMsg(''),4000);};

  useEffect(()=>{api.getLabStats().then(r=>setStats(r.data||{})).catch(()=>{});api.getDoctors().then(r=>setOrderDoctors(r.data||[])).catch(()=>{});},[]);

  const loadTab=useCallback(async()=>{
    setLoading(true);
    try{
      if(tab==='orders'){const r=await api.getLabRequests({status:filterStatus||undefined,skip:0,take:50});setOrders(r.data.data||[]);setOrderTotal(r.data.total||0);}
      if(tab==='tests'||tab==='panels'||tab==='orders'){const [t,p]=await Promise.all([api.getLabTests(),api.getLabPanels()]);setLabTests(t.data||[]);setLabPanels(p.data||[]);}
      if(tab==='collect'){const r=await api.getLabRequests({status:'ORDERED',take:100});setPendingOrders(r.data.data||[]);}
      if(tab==='reports'){const r=await api.getLabReports(reportDates);setReportData(r.data);}
    }catch{}finally{setLoading(false);}
  },[tab,filterStatus,reportDates]);
  useEffect(()=>{loadTab();},[loadTab]);

  // ── Create Order ──
  const submitOrder=async(e:React.FormEvent)=>{
    e.preventDefault();
    if(!orderForm.patientId){notify('⚠️ Select a patient');return;}
    if(!selectedTests.length&&!selectedPanels.length){notify('⚠️ Select at least one test or panel');return;}
    setSaving(true);
    const selTestObjs=labTests.filter((t:any)=>selectedTests.includes(t.id)).map((t:any)=>({testId:t.id,testName:t.testName,testCode:t.testCode,sampleType:t.sampleType,price:t.price}));
    try{
      await api.createLabRequest({branchId:getActiveBranchId()||undefined,...orderForm,tests:selTestObjs,panelIds:selectedPanels});
      notify('✅ Lab order created!');setShowOrderForm(false);setSelectedTests([]);setSelectedPanels([]);setOrderPatient(null);setOrderForm({patientId:'',doctorId:'',priority:'ROUTINE',clinicalNotes:'',fastingRequired:false,admissionId:'',visitId:''});loadTab();
    }catch(e:any){notify('❌ '+(e.response?.data?.message||'Error'));}
    finally{setSaving(false);}
  };

  const openOrderDetail=async(order:any)=>{
    setSelectedOrder(order);
    const r=await api.getLabOrder(order.id);
    setSelectedOrder(r.data);
    const res=await api.getLabResults(order.id);
    setOrderResults(res.data||[]);
    setShowOrderDetail(true);
  };

  // ── Sample Collect ──
  const submitCollect=async(e:React.FormEvent)=>{
    e.preventDefault();
    if(!collectForm.requestId){notify('⚠️ Select an order');return;}
    setSaving(true);
    try{
      await api.collectSample(collectForm);
      notify('✅ Sample collected! Barcode generated.');setShowCollect(false);setCollectForm({requestId:'',patientId:'',sampleType:'BLOOD',containerType:'EDTA (Purple)',collectionLocation:'OPD',barcode:''});loadTab();
    }catch(e:any){notify('❌ '+(e.response?.data?.message||'Error'));}
    finally{setSaving(false);}
  };

  // ── Result Entry ──
  const openResultEntry=(order:any)=>{
    nav(`/laboratory/results/${order.id}`);
  };

    // ── Print Report ──
  const printReport=async(order:any)=>{
    const detail=await api.getLabOrder(order.id);
    const d=detail.data;
    const params=d.parameters||d.results?.[0]?.parameters||[];
    const patientName=`${d.patient_first_name||d.firstName||''} ${d.patient_last_name||d.lastName||''}`.trim()||d.patientId||'—';
    const doctorName=d.doctor_first_name?`Dr. ${d.doctor_first_name} ${d.doctor_last_name||''}`:d.doctorId||'—';
    const paramRows=params.length>0?params.map((p:any)=>{
      const low=parseFloat(p.normalRangeLow||p.normal_range_low);
      const high=parseFloat(p.normalRangeHigh||p.normal_range_high);
      const val=parseFloat(p.resultValue||p.result_value);
      const flag=p.isCritical||p.is_critical?'⚠️ CRITICAL':p.isAbnormal||p.is_abnormal?(val<low?'↓ LOW':'↑ HIGH'):'Normal';
      const abnormal=p.isAbnormal||p.is_abnormal||p.isCritical||p.is_critical;
      return `<tr style="${p.isCritical||p.is_critical?'background:#fee2e2':''}"><td>${p.parameterName||p.parameter_name||'—'}</td><td style="font-weight:${abnormal?'700':'400'};color:${abnormal?'#dc2626':'inherit'}">${p.resultValue||p.result_value||'—'}</td><td>${p.unit||'—'}</td><td>${p.normalRangeText||p.normal_range_text||(p.normalRangeLow&&p.normalRangeHigh?`${p.normalRangeLow}–${p.normalRangeHigh}`:'—')}</td><td style="font-weight:600;color:${abnormal?'#dc2626':'#15803d'}">${flag}</td></tr>`;
    }).join(''):`<tr><td colspan="5" style="text-align:center;color:#888;">Results pending</td></tr>`;

    const html=`
      <div class="section">
        <div class="row">
          <div class="field"><div class="lbl">Patient</div><div class="val">${patientName}</div></div>
          <div class="field"><div class="lbl">Doctor</div><div class="val">${doctorName}</div></div>
          <div class="field"><div class="lbl">Order No.</div><div class="val">${d.requestNumber||d.request_number||'—'}</div></div>
          <div class="field"><div class="lbl">Priority</div><div class="val">${d.priority||'ROUTINE'}</div></div>
        </div>
        <div class="row">
          <div class="field"><div class="lbl">Ordered</div><div class="val">${fmtDateTime(d.createdAt||d.created_at)}</div></div>
          <div class="field"><div class="lbl">Sample Collected</div><div class="val">${d.sampleCollectedAt||d.sample_collected_at?fmtDateTime(d.sampleCollectedAt||d.sample_collected_at):'Pending'}</div></div>
          <div class="field"><div class="lbl">Status</div><div class="val">${d.status||'—'}</div></div>
        </div>
      </div>
      <table>
        <thead><tr><th>Test / Parameter</th><th>Result</th><th>Unit</th><th>Reference Range</th><th>Flag</th></tr></thead>
        <tbody>${paramRows}</tbody>
      </table>
      ${d.results?.[0]?.interpretation?`<div class="section"><h4>Interpretation / Remarks</h4><p>${d.results[0].interpretation}</p></div>`:''}
    `;
    await openTemplatedPrintWindow({
      api, contentHtml:html, docTitle:'Laboratory Report', reportType:'NORMAL',
      barcodeText:d.requestNumber||d.request_number||d.id,
      noteText:'This report is computer generated. Results should be interpreted by a qualified physician.',
    });
  };

    // ── Culture Submit ──
  const submitCulture=async(e:React.FormEvent)=>{
    e.preventDefault();
    setSaving(true);
    try{
      await api.saveLabCulture({...cultureForm,antibiotics:abxRows.filter(a=>a.antibiotic)});
      notify('✅ Culture report saved!');setShowCulture(false);loadTab();
    }catch(e:any){notify('❌ '+(e.response?.data?.message||'Error'));}
    finally{setSaving(false);}
  };

  const TABS=[['orders','📋 Orders'],['tests','🧪 Test Master'],['panels','📦 Panels'],['collect','🔬 Sample Collection'],['results','📊 Result Entry'],['culture','🦠 Microbiology'],['reports','📈 Reports'],['new_order','➕ New Order']];

  return(
    <Layout title="Laboratory (LIS)" actions={
      <div className="flex gap-2">
        {tab==='orders'&&<button onClick={()=>setTab('new_order')} className="btn-primary text-sm">➕ New Order</button>}
        {tab==='tests'&&<button onClick={()=>{setTestForm({testName:'',testCode:'',testCategory:'Biochemistry',department:'Biochemistry',sampleType:'Blood',unit:'',normalRange:'',methodology:'',turnAroundTimeHours:'24',price:'',gstPercentage:'18',consultationId:'',admissionId:'',sampleCollectedBy:'',sampleBarcode:'',reportGeneratedAt:'',requestedBy:''});setEditTestId(null);setShowTestForm(true);}} className="btn-primary text-sm">➕ Add Test</button>}
        {tab==='panels'&&<button onClick={()=>setShowPanelForm(true)} className="btn-primary text-sm">➕ Add Panel</button>}
        {tab==='collect'&&<button onClick={()=>setShowCollect(true)} className="btn-primary text-sm">🔬 Collect Sample</button>}
        {tab==='culture'&&<button onClick={()=>setShowCulture(true)} className="btn-primary text-sm">🦠 Enter Culture</button>}
      </div>
    }>
      {msg&&<div className={`mb-4 p-3 rounded-lg text-sm border ${msg.startsWith('✅')?'bg-green-50 text-green-700 border-green-200':msg.startsWith('⚠️')?'bg-amber-50 text-amber-700 border-amber-200':'bg-red-50 text-red-700 border-red-200'}`}>{msg}</div>}

      <div className="grid grid-cols-2 lg:grid-cols-6 gap-3 mb-5">
        <StatCard label="Today's Orders" value={stats.todayRequests||0} icon="🔬" color="blue"/>
        <StatCard label="Pending" value={stats.pending||0} icon="⏳" color="amber"/>
        <StatCard label="Pending Collection" value={stats.samplesPending||0} icon="🧪" color="slate"/>
        <StatCard label="Pending Verification" value={stats.pendingVerification||0} icon="✔️" color="purple"/>
        <StatCard label="Completed" value={stats.completed||0} icon="✅" color="green"/>
        <StatCard label="Critical Values" value={stats.critical||0} icon="⚠️" color="red"/>
      </div>

      <div className="flex gap-1 mb-4 overflow-x-auto pb-1 border-b">
        {TABS.map(([t,l])=>(
          <button key={t} onClick={()=>setTab(t as any)}
            className={`px-3 py-2 rounded-t-lg text-xs font-medium whitespace-nowrap transition-all flex-shrink-0 ${tab===t?'bg-[#02357A] text-white':'text-slate-600 hover:bg-slate-100'}`}>{l}</button>
        ))}
      </div>

      {/* ORDERS */}
      {tab==='orders'&&(
        <div>
          <div className="flex flex-wrap gap-2 mb-4">
            {['','ORDERED','SAMPLE_COLLECTED','PROCESSING','COMPLETED','CANCELLED'].map(s=>(
              <button key={s} onClick={()=>setFilterStatus(s)}
                className={`text-xs px-3 py-1.5 rounded-full border font-medium transition-all ${filterStatus===s?'bg-[#02357A] text-white border-[#015CA6]':'border-slate-300 text-slate-600 hover:bg-slate-50'}`}>
                {s||'All'} {s===filterStatus&&orderTotal>0&&`(${orderTotal})`}
              </button>
            ))}
          </div>
          <div className="card overflow-hidden">
            <DataTable loading={loading} emptyMessage="No lab orders" emptyIcon="🔬" data={orders} columns={[
              {key:'no',label:'Order #',render:(r:any)=><span className="font-mono text-xs">{(r.request_number||r.requestNumber)}</span>},
              {key:'patient',label:'Patient',render:(r:any)=><span className="text-slate-700">{r.patient_first_name?`${r.patient_first_name} ${r.patient_last_name||''}`:(r.patient_id||r.patientId||'—')}</span>},
              {key:'tests',label:'Tests',render:(r:any)=><span className="text-slate-600 text-sm">{safeArray(r.tests).length} test(s)</span>},
              {key:'priority',label:'Priority',render:(r:any)=><Badge label={r.priority||'ROUTINE'} className={r.priority==='STAT'?'bg-red-100 text-red-700':r.priority==='URGENT'?'bg-amber-100 text-amber-700':'bg-blue-50 text-[#02357A]'}/>},
              {key:'status',label:'Status',render:(r:any)=><span className={`text-xs px-2 py-0.5 rounded-full font-semibold ${STATUS_COLOR[r.status]||'bg-slate-100 text-slate-500'}`}>{r.status}</span>},
              {key:'date',label:'Date',render:(r:any)=><span className="text-xs text-slate-400">{fmtDate(r.createdAt)}</span>},
              {key:'actions',label:'',render:(r:any)=>(
                <div className="flex gap-2 flex-wrap">
                  <button onClick={()=>openOrderDetail(r)} className="text-xs text-[#02357A] hover:underline">View</button>
                  {r.status==='ORDERED'&&<button onClick={()=>{setCollectForm({requestId:r.id,patientId:(r.patient_id||r.patientId),sampleType:'BLOOD',containerType:'EDTA (Purple)',collectionLocation:'OPD',barcode:''});setShowCollect(true);}} className="text-xs text-[#039089] hover:underline">Collect</button>}
                  {(r.status==='SAMPLE_COLLECTED'||r.status==='PROCESSING')&&<button onClick={()=>openResultEntry(r)} className="text-xs text-amber-600 hover:underline">Enter Results</button>}
                  {r.status==='TECH_VERIFIED'&&<button onClick={async()=>{try{await api.verifyResult(r.id,{level:'PATHOLOGIST'});notify('✅ Approved by Pathologist!');loadTab();}catch(e:any){notify('❌ '+(e.response?.data?.message||'Error'));}}} className="text-xs bg-purple-100 text-purple-700 hover:bg-purple-200 px-2 py-0.5 rounded font-semibold">🔬 Approve</button>}
                  {r.status==='VERIFIED'&&<span className="text-xs bg-green-100 text-green-700 px-2 py-0.5 rounded font-semibold">✅ Verified</span>}
                  {r.status==='COMPLETED'&&<button onClick={()=>printReport(r)} className="text-xs text-green-600 hover:underline">🖨️ Print</button>}
                </div>
              )},
            ]}/>
          </div>
        </div>
      )}

      {/* TEST MASTER */}
      {tab==='tests'&&(
        <div className="card overflow-hidden">
          <DataTable loading={loading} emptyMessage="No tests in master" emptyIcon="🧪" data={labTests} columns={[
            {key:'code',label:'Code',render:(r:any)=><span className="font-mono text-xs bg-slate-100 px-1.5 py-0.5 rounded">{r.testCode||'—'}</span>},
            {key:'name',label:'Test Name',render:(r:any)=><div><p className="font-medium">{r.testName}</p><p className="text-xs text-slate-400">{r.methodology}</p></div>},
            {key:'dept',label:'Department',render:(r:any)=><Badge label={r.department||r.testCategory||'—'} className="bg-purple-50 text-purple-700"/>},
            {key:'sample',label:'Sample',render:(r:any)=><span className="text-slate-500 text-xs">{r.sampleType||'—'}</span>},
            {key:'unit',label:'Unit / Range',render:(r:any)=><div><p className="text-xs">{r.unit||'—'}</p><p className="text-xs text-slate-400">{r.normalRange||'—'}</p></div>},
            {key:'tat',label:'TAT',render:(r:any)=><span className="text-xs">{r.turnAroundTimeHours||24}h</span>},
            {key:'price',label:'Price',render:(r:any)=><span className="font-semibold text-green-600">₹{parseFloat(r.price||0).toFixed(0)}</span>},
            {key:'actions',label:'',render:(r:any)=><button onClick={()=>{setTestForm({testName:r.testName,testCode:r.testCode||'',testCategory:r.testCategory||'',department:r.department||'',sampleType:r.sampleType||'Blood',unit:r.unit||'',normalRange:r.normalRange||'',methodology:r.methodology||'',turnAroundTimeHours:r.turnAroundTimeHours||24,price:r.price||'',gstPercentage:r.gstPercentage||18,consultationId:'',admissionId:'',sampleCollectedBy:'',sampleBarcode:'',reportGeneratedAt:'',requestedBy:''});setEditTestId(r.id);setShowTestForm(true);}} className="text-xs text-[#02357A] hover:underline">Edit</button>},
          ]}/>
        </div>
      )}

      {/* PANELS */}
      {tab==='panels'&&(
        <div className="space-y-3">
          {labPanels.map((p:any)=>(
            <div key={p.id} className="card p-4">
              <div className="flex items-center justify-between mb-2">
                <div><p className="font-semibold text-slate-700">{p.panelName}</p><p className="text-xs text-slate-400">{p.panelCode} · {p.department} · TAT: {p.turnAroundTimeHours}h</p></div>
                <span className="font-bold text-green-600 text-lg">₹{parseFloat(p.price||0).toLocaleString('en-IN')}</span>
              </div>
              {p.tests?.length>0&&<div className="flex flex-wrap gap-1.5">{p.tests.map((t:any)=><span key={t.id} className="text-xs bg-blue-50 text-[#02357A] px-2 py-0.5 rounded-full">{t.testName}</span>)}</div>}
            </div>
          ))}
          {!loading&&!labPanels.length&&<div className="card p-12 text-center text-slate-400">No panels defined yet</div>}
        </div>
      )}

      {/* SAMPLE COLLECTION */}
      {tab==='collect'&&(
        <div>
          <div className="card overflow-hidden mb-4">
            <div className="p-4 border-b"><h3 className="font-semibold text-slate-700">Pending Sample Collection ({pendingOrders.length})</h3></div>
            <DataTable loading={loading} emptyMessage="No pending collections" emptyIcon="✅" data={pendingOrders} columns={[
              {key:'no',label:'Order #',render:(r:any)=><span className="font-mono text-xs">{(r.request_number||r.requestNumber)}</span>},
              {key:'patient',label:'Patient',render:(r:any)=><span>{r.patient_first_name?`${r.patient_first_name} ${r.patient_last_name||''}`:(r.patient_id||r.patientId||'—')}</span>},
              {key:'tests',label:'Tests',render:(r:any)=><span className="text-slate-600 text-sm">{safeArray(r.tests).map((t:any)=>t.testName||'').join(', ')}</span>},
              {key:'priority',label:'Priority',render:(r:any)=><Badge label={r.priority||'ROUTINE'} className={r.priority==='STAT'?'bg-red-100 text-red-700':'bg-blue-50 text-[#02357A]'}/>},
              {key:'actions',label:'',render:(r:any)=>(
                <button onClick={()=>{setCollectForm({requestId:r.id,patientId:(r.patient_id||r.patientId),sampleType:safeArray(r.tests)[0]?.sampleType||'BLOOD',containerType:'EDTA (Purple)',collectionLocation:'OPD',barcode:''});setShowCollect(true);}} className="text-xs text-[#039089] hover:underline font-medium">Collect Sample</button>
              )},
            ]}/>
          </div>
        </div>
      )}

      {/* RESULT ENTRY */}
      {tab==='results'&&(
        <div>
          <p className="text-sm text-slate-500 mb-4">Select an order from the Orders tab and click "Enter Results" to enter parameters, or use the button below to pick an order in Processing state.</p>
          <div className="card overflow-hidden">
            <div className="p-4 border-b"><h3 className="font-semibold text-slate-700">Orders Awaiting Results</h3></div>
            <DataTable loading={loading} emptyMessage="No orders pending result entry" emptyIcon="📊"
              data={orders.filter((o:any)=>o.status==='SAMPLE_COLLECTED'||o.status==='PROCESSING')}
              columns={[
                {key:'no',label:'Order #',render:(r:any)=><span className="font-mono text-xs">{(r.request_number||r.requestNumber)}</span>},
                {key:'patient',label:'Patient',render:(r:any)=><span>{r.patient_first_name?`${r.patient_first_name} ${r.patient_last_name||''}`:(r.patient_id||r.patientId||'—')}</span>},
                {key:'tests',label:'Tests',render:(r:any)=><span className="text-slate-600 text-sm">{safeArray(r.tests).map((t:any)=>t.testName||'').join(', ')}</span>},
                {key:'status',label:'Status',render:(r:any)=><span className={`text-xs px-2 py-0.5 rounded-full font-semibold ${STATUS_COLOR[r.status]||''}`}>{r.status}</span>},
                {key:'actions',label:'',render:(r:any)=><div className="flex gap-2"><button onClick={()=>openResultEntry(r)} className="text-xs text-amber-600 hover:underline font-medium">Enter Results</button>{r.status==='TECH_VERIFIED'&&<button onClick={async()=>{try{await api.verifyResult(r.id,{level:'PATHOLOGIST'});notify('✅ Approved!');loadTab();}catch{}}} className="text-xs bg-purple-100 text-purple-700 hover:bg-purple-200 px-2 py-0.5 rounded font-semibold">🔬 Approve</button>}</div>},
              ]}/>
          </div>
        </div>
      )}

      {/* MICROBIOLOGY / CULTURE */}
      {tab==='culture'&&(
        <div>
          <p className="text-sm text-slate-500 mb-4">For Microbiology orders — enter culture results, growth status, organism identification, and antibiotic sensitivity (C&S).</p>
          <div className="card p-6 text-center">
            <span className="text-5xl block mb-2">🦠</span>
            <p className="text-slate-600 font-medium mb-4">Click "Enter Culture" to record microbiology results for a lab order</p>
            <button onClick={()=>setShowCulture(true)} className="btn-primary">🦠 Enter Culture Report</button>
          </div>
        </div>
      )}

      {/* REPORTS */}
      {tab==='reports'&&(
        <div>
          <div className="card p-4 mb-5 flex gap-3 items-end flex-wrap">
            <div><label className="label">From</label><Input type="date" value={reportDates.from} onChange={e=>setRD({...reportDates,from:e.target.value})}/></div>
            <div><label className="label">To</label><Input type="date" value={reportDates.to} onChange={e=>setRD({...reportDates,to:e.target.value})}/></div>
            <button onClick={loadTab} className="btn-primary text-sm mb-0.5">Apply</button>
          </div>
          {reportData&&(
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-5">
              <div className="card overflow-hidden">
                <div className="p-4 border-b"><h3 className="font-semibold text-slate-700">Daily Order Count</h3></div>
                <div className="divide-y max-h-64 overflow-y-auto">
                  {(reportData.dailyCounts||[]).map((d:any)=>(
                    <div key={d.date} className="flex justify-between p-3 text-sm">
                      <span className="text-slate-600">{fmtDate(d.date)}</span>
                      <span className="font-semibold text-[#02357A]">{d.orders} orders</span>
                    </div>
                  ))}
                </div>
              </div>
              <div className="card overflow-hidden">
                <div className="p-4 border-b flex justify-between items-center"><h3 className="font-semibold text-slate-700">Top Tests</h3><span className="font-bold text-green-600">Revenue: ₹{reportData.totalRevenue?.toLocaleString('en-IN')}</span></div>
                <div className="divide-y">
                  {(reportData.topTests||[]).map((t:any,i:number)=>(
                    <div key={i} className="flex items-center justify-between p-3 text-sm">
                      <div className="flex items-center gap-2"><span className="w-6 h-6 rounded-full bg-blue-50 text-[#02357A] flex items-center justify-center text-xs font-bold">{i+1}</span><span>{t.test_name}</span></div>
                      <span className="font-semibold text-slate-600">{t.count}×</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          )}
        </div>
      )}

      {/* ─── MODALS ─── */}

      {tab==='new_order'&&(
        <div className="max-w-3xl">
        <form onSubmit={submitOrder} className="space-y-4">
          <div className="grid grid-cols-2 gap-3">
            <div className="col-span-2">
              <PatientSearchInput label="Patient *" selected={orderPatient}
                onSelect={(p:any)=>{setOrderPatient(p);setOrderForm({...orderForm,patientId:p.id});}}
                onClear={()=>{setOrderPatient(null);setOrderForm({...orderForm,patientId:''});}}/>
            </div>
            <div><label className="label">Doctor</label>
              <Select value={orderForm.doctorId} onChange={e=>setOrderForm({...orderForm,doctorId:e.target.value})}>
                <option value="">Select Doctor (optional)</option>
                {orderDoctors.map((d:any)=><option key={d.id} value={d.id}>Dr. {d.firstName} {d.lastName}</option>)}
              </Select>
            </div>
            <div><label className="label">Priority</label>
              <Select value={orderForm.priority} onChange={e=>setOrderForm({...orderForm,priority:e.target.value})}>
                {PRIORITIES.map(p=><option key={p}>{p}</option>)}
              </Select>
            </div>
          </div>

          <div>
            <p className="label mb-2">Select Panels</p>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-2 mb-3">
              {labPanels.map((p:any)=>(
                <label key={p.id} className={`flex items-start gap-2 p-2.5 border rounded-lg cursor-pointer text-xs transition-all ${selectedPanels.includes(p.id)?'border-[#015CA6] bg-blue-50':'border-slate-200 hover:border-blue-300'}`}>
                  <input type="checkbox" checked={selectedPanels.includes(p.id)} onChange={e=>{setSelectedPanels(e.target.checked?[...selectedPanels,p.id]:selectedPanels.filter(x=>x!==p.id));}} className="mt-0.5"/>
                  <div><p className="font-semibold">{p.panelName}</p><p className="text-green-600 font-medium mt-0.5">₹{parseFloat(p.price||0).toFixed(0)}</p></div>
                </label>
              ))}
            </div>
            <p className="label mb-2">Or Select Individual Tests</p>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-1.5 max-h-44 overflow-y-auto">
              {labTests.map((t:any)=>(
                <label key={t.id} className={`flex items-center gap-1.5 p-2 border rounded-lg cursor-pointer text-xs transition-all ${selectedTests.includes(t.id)?'border-[#015CA6] bg-blue-50':'border-slate-200 hover:border-blue-200'}`}>
                  <input type="checkbox" checked={selectedTests.includes(t.id)} onChange={e=>{setSelectedTests(e.target.checked?[...selectedTests,t.id]:selectedTests.filter(x=>x!==t.id));}} className="flex-shrink-0"/>
                  <div><p className="font-medium leading-tight">{t.testName}</p><p className="text-slate-400 text-xs">{t.testCode} · ₹{t.price||0}</p></div>
                </label>
              ))}
            </div>
          </div>

          <div className="grid grid-cols-2 gap-3">
            <div className="col-span-2"><label className="label">Clinical Notes</label><Input value={orderForm.clinicalNotes} onChange={e=>setOrderForm({...orderForm,clinicalNotes:e.target.value})} placeholder="Clinical indication, symptoms..."/></div>
            <div className="col-span-2">
              <AdmissionSearchInput
                label="Link to IPD Admission (optional — for IPD patients)"
                placeholder="Search admitted patient to auto-link billing..."
                onSelect={(a:any)=>setOrderForm((f:any)=>({...f,admissionId:a.id,patientId:f.patientId||a.patientId||a.patient_id||f.patientId,visitId:''}))}
                onClear={()=>setOrderForm((f:any)=>({...f,admissionId:''}))}
              />
              {orderForm.admissionId&&<p className="text-xs text-emerald-600 font-medium mt-1">✓ IPD admission linked — charge will auto-post to IPD bill</p>}
            </div>
          </div>
          <label className="flex items-center gap-2 text-sm"><input type="checkbox" checked={orderForm.fastingRequired} onChange={e=>setOrderForm({...orderForm,fastingRequired:e.target.checked})} className="w-4 h-4"/><span>Fasting required</span></label>
          {selectedTests.length+selectedPanels.length>0&&(
            <div className="bg-blue-50 border border-blue-200 rounded-lg p-3 text-sm"><span className="font-semibold">{selectedTests.length} test(s) + {selectedPanels.length} panel(s) selected</span> · Estimated total: ₹{(labTests.filter((t:any)=>selectedTests.includes(t.id)).reduce((s:number,t:any)=>s+parseFloat(t.price||0),0)+labPanels.filter((p:any)=>selectedPanels.includes(p.id)).reduce((s:number,p:any)=>s+parseFloat(p.price||0),0)).toLocaleString('en-IN')}</div>
          )}
          <div className="flex gap-3"><button type="submit" disabled={saving||!orderForm.patientId} className="btn-primary flex-1">{saving?'Creating...':'Create Order'}</button><button type="button" onClick={()=>setTab('orders')} className="btn-secondary">Cancel</button></div>
        </form>
        </div>
      )}

      {/* Order Detail */}
      <SlidePanel isOpen={showOrderDetail} onClose={()=>setShowOrderDetail(false)} title={`Order: ${selectedOrder?.requestNumber||''}`} size="lg">
        {selectedOrder&&(
          <div className="space-y-4">
            <div className="grid grid-cols-2 md:grid-cols-3 gap-3 text-sm">
              {[['Status',selectedOrder.status],['Priority',selectedOrder.priority||'ROUTINE'],['Sample Collected',selectedOrder.sampleCollectedAt?fmtDateTime(selectedOrder.sampleCollectedAt):'Pending'],['Barcode',selectedOrder.sampleBarcode||'—']].map(([l,v])=>(
                <div key={l as string} className="bg-slate-50 p-3 rounded-lg"><p className="text-slate-400 text-xs">{l}</p><p className="font-semibold mt-0.5">{v}</p></div>
              ))}
            </div>
            <div>
              <p className="label mb-2">Tests Ordered</p>
              {safeArray(selectedOrder.tests).map((t:any,i:number)=>(
                <div key={i} className="flex justify-between text-sm p-2 bg-slate-50 rounded mb-1">
                  <span className="font-medium">{t.testName}</span><span className="text-slate-400">{t.sampleType} · ₹{t.price||0}</span>
                </div>
              ))}
            </div>
            {orderResults.length>0&&(
              <div>
                <p className="label mb-2">Results</p>
                {orderResults.map((r:any)=>(
                  <div key={r.id} className="mb-3">
                    <div className="flex justify-between text-sm mb-1"><span className="font-medium">{r.testId}</span><span className={`text-xs px-2 py-0.5 rounded-full ${r.status==='VERIFIED'?'bg-green-100 text-green-700':'bg-amber-100 text-amber-700'}`}>{r.status}</span></div>
                    {(r.parameters||[]).map((p:any)=>(
                      <div key={p.id} className={`flex items-center justify-between text-xs p-2 border rounded mb-0.5 ${p.isCritical?'border-red-400 bg-red-50':p.isAbnormal?'border-amber-300 bg-amber-50':'border-slate-200'}`}>
                        <span className="text-slate-700">{p.parameterName}</span>
                        <span className={`font-bold ${p.isCritical?'text-red-700':p.isAbnormal?'text-amber-700':''}`}>{p.resultValue||'—'} {p.unit}</span>
                        <span className="text-slate-400">{p.normalRangeText||(p.normalRangeLow&&p.normalRangeHigh?`${p.normalRangeLow}–${p.normalRangeHigh}`:'')}</span>
                        {p.isCritical&&<span className="text-red-600 font-bold">⚠️ CRITICAL</span>}
                        {!p.isCritical&&p.isAbnormal&&<span className="text-amber-600">ABNORMAL</span>}
                      </div>
                    ))}
                  </div>
                ))}
              </div>
            )}
            <div className="flex gap-2">
              {(selectedOrder.status==='SAMPLE_COLLECTED'||selectedOrder.status==='PROCESSING')&&<button onClick={()=>{setShowOrderDetail(false);openResultEntry(selectedOrder);}} className="btn-primary text-sm">Enter Results</button>}
              {selectedOrder.status==='COMPLETED'&&<button onClick={()=>printReport(selectedOrder)} className="btn-primary text-sm">🖨️ Print Report</button>}
            </div>
          </div>
        )}
      </SlidePanel>

      {/* Test Form */}
      <SlidePanel isOpen={showTestForm} onClose={()=>setShowTestForm(false)} title={editTestId?'Edit Test':'Add Test'} size="md">
        <form onSubmit={async e=>{e.preventDefault();setSaving(true);try{if(editTestId)await api.updateLabTest(editTestId,testForm);else await api.createLabTest(testForm);notify('✅ Test saved!');setShowTestForm(false);loadTab();}catch(e:any){notify('❌ '+(e.response?.data?.message||'Error'));}finally{setSaving(false);}}} className="grid grid-cols-2 gap-3">
          <div className="col-span-2"><label className="label">Test Name *</label><Input value={testForm.testName} onChange={e=>setTestForm({...testForm,testName:e.target.value})} required/></div>
          <div><label className="label">Test Code *</label><Input value={testForm.testCode} onChange={e=>setTestForm({...testForm,testCode:e.target.value})} required/></div>
          <div><label className="label">Department</label><Select value={testForm.department} onChange={e=>setTestForm({...testForm,department:e.target.value})}>{DEPARTMENTS.map(d=><option key={d}>{d}</option>)}</Select></div>
          <div><label className="label">Category</label><Input value={testForm.testCategory} onChange={e=>setTestForm({...testForm,testCategory:e.target.value})} placeholder="e.g. Hematology"/></div>
          <div><label className="label">Sample Type</label><Select value={testForm.sampleType} onChange={e=>setTestForm({...testForm,sampleType:e.target.value})}>{SAMPLE_TYPES.map(s=><option key={s}>{s}</option>)}</Select></div>
          <div><label className="label">Unit</label><Input value={testForm.unit} onChange={e=>setTestForm({...testForm,unit:e.target.value})} placeholder="e.g. g/dL"/></div>
          <div><label className="label">Normal Range</label><Input value={testForm.normalRange} onChange={e=>setTestForm({...testForm,normalRange:e.target.value})} placeholder="e.g. 12-17"/></div>
          <div><label className="label">Methodology</label><Input value={testForm.methodology} onChange={e=>setTestForm({...testForm,methodology:e.target.value})} placeholder="e.g. HPLC, Enzymatic"/></div>
          <div><label className="label">TAT (hours)</label><Input type="number" value={testForm.turnAroundTimeHours} onChange={e=>setTestForm({...testForm,turnAroundTimeHours:e.target.value})}/></div>
          <div><label className="label">Price (₹)</label><Input type="number" value={testForm.price} onChange={e=>setTestForm({...testForm,price:e.target.value})}/></div>
          <div><label className="label">GST %</label><Input type="number" value={testForm.gstPercentage} onChange={e=>setTestForm({...testForm,gstPercentage:e.target.value})}/></div>
          <div className="col-span-2 flex gap-3"><button type="submit" disabled={saving} className="btn-primary flex-1">{saving?'Saving...':editTestId?'Update':'Add Test'}</button><button type="button" onClick={()=>setShowTestForm(false)} className="btn-secondary">Cancel</button></div>
        </form>
      </SlidePanel>

      {/* Panel Form */}
      <SlidePanel isOpen={showPanelForm} onClose={()=>setShowPanelForm(false)} title="Add Test Panel / Profile" size="md">
        <form onSubmit={async e=>{e.preventDefault();setSaving(true);try{await api.createLabPanel(panelForm);notify('✅ Panel created!');setShowPanelForm(false);setPanelForm({panelCode:'',panelName:'',department:'Biochemistry',description:'',price:'',turnAroundTimeHours:'24',tests:[]});loadTab();}catch(e:any){notify('❌ '+(e.response?.data?.message||'Error'));}finally{setSaving(false);}}} className="space-y-3">
          <div className="grid grid-cols-2 gap-3">
            <div><label className="label">Panel Code *</label><Input value={panelForm.panelCode} onChange={e=>setPanelForm({...panelForm,panelCode:e.target.value})} required placeholder="e.g. CBC"/></div>
            <div><label className="label">Panel Name *</label><Input value={panelForm.panelName} onChange={e=>setPanelForm({...panelForm,panelName:e.target.value})} required/></div>
            <div><label className="label">Department</label><Select value={panelForm.department} onChange={e=>setPanelForm({...panelForm,department:e.target.value})}>{DEPARTMENTS.map(d=><option key={d}>{d}</option>)}</Select></div>
            <div><label className="label">Price (₹)</label><Input type="number" value={panelForm.price} onChange={e=>setPanelForm({...panelForm,price:e.target.value})}/></div>
            <div><label className="label">TAT (hours)</label><Input type="number" value={panelForm.turnAroundTimeHours} onChange={e=>setPanelForm({...panelForm,turnAroundTimeHours:e.target.value})}/></div>
          </div>
          <div><label className="label">Description</label><Input value={panelForm.description} onChange={e=>setPanelForm({...panelForm,description:e.target.value})}/></div>
          <div>
            <p className="label mb-2">Included Tests</p>
            <div className="grid grid-cols-2 gap-1.5 max-h-40 overflow-y-auto">
              {labTests.map((t:any)=>(
                <label key={t.id} className={`flex items-center gap-1.5 p-2 border rounded text-xs cursor-pointer ${panelForm.tests.includes(t.id)?'border-blue-400 bg-blue-50':'border-slate-200'}`}>
                  <input type="checkbox" checked={panelForm.tests.includes(t.id)} onChange={e=>setPanelForm({...panelForm,tests:e.target.checked?[...panelForm.tests,t.id]:panelForm.tests.filter(x=>x!==t.id)})} className="w-3 h-3"/>
                  <span>{t.testName}</span>
                </label>
              ))}
            </div>
          </div>
          <div className="flex gap-3"><button type="submit" disabled={saving} className="btn-primary flex-1">{saving?'Creating...':'Create Panel'}</button><button type="button" onClick={()=>setShowPanelForm(false)} className="btn-secondary">Cancel</button></div>
        </form>
      </SlidePanel>

      {/* Sample Collection */}
      <SlidePanel isOpen={showCollect} onClose={()=>setShowCollect(false)} title="Sample Collection" size="md">
        <form onSubmit={submitCollect} className="space-y-3">
          {!collectForm.requestId&&(
            <div><label className="label">Select Order *</label>
              <Select value={collectForm.requestId} onChange={e=>{const o=pendingOrders.find((x:any)=>x.id===e.target.value);setCollectForm({...collectForm,requestId:e.target.value,patientId:o?.patientId||''});}} required>
                <option value="">Select order</option>
                {pendingOrders.map((o:any)=><option key={o.id} value={o.id}>{(o.request_number||o.requestNumber)} — {(o.patient_id||o.patientId)}</option>)}
              </Select>
            </div>
          )}
          {collectForm.requestId&&<div className="p-2 bg-blue-50 rounded text-xs font-mono text-[#02357A]">Order: {pendingOrders.find((o:any)=>o.id===collectForm.requestId)?.requestNumber||collectForm.requestId}</div>}
          <div className="grid grid-cols-2 gap-3">
            <div><label className="label">Sample Type *</label><Select value={collectForm.sampleType} onChange={e=>setCollectForm({...collectForm,sampleType:e.target.value})} required>{SAMPLE_TYPES.map(s=><option key={s}>{s}</option>)}</Select></div>
            <div><label className="label">Container Type</label><Select value={collectForm.containerType} onChange={e=>setCollectForm({...collectForm,containerType:e.target.value})}>{CONTAINER_TYPES.map(c=><option key={c}>{c}</option>)}</Select></div>
            <div><label className="label">Collection Location</label><Select value={collectForm.collectionLocation} onChange={e=>setCollectForm({...collectForm,collectionLocation:e.target.value})}>
              {['OPD','IPD','EMERGENCY','EXTERNAL'].map(l=><option key={l}>{l}</option>)}
            </Select></div>
            <div><label className="label">Barcode (optional)</label><Input value={collectForm.barcode} onChange={e=>setCollectForm({...collectForm,barcode:e.target.value})} placeholder="Scan or auto-generate"/></div>
          </div>
          <div className="flex gap-3"><button type="submit" disabled={saving} className="btn-primary flex-1">{saving?'Collecting...':'Collect & Generate Barcode'}</button><button type="button" onClick={()=>setShowCollect(false)} className="btn-secondary">Cancel</button></div>
        </form>
      </SlidePanel>

      

      {/* Culture & Sensitivity */}
      <SlidePanel isOpen={showCulture} onClose={()=>setShowCulture(false)} title="Microbiology — Culture Report" size="xl">
        <form onSubmit={submitCulture} className="space-y-4">
          <div>
            <label className="label">Lab Order *</label>
            <Select value={cultureForm.requestId} onChange={e=>setCultureForm({...cultureForm,requestId:e.target.value})} required>
              <option value="">Select lab order</option>
              {orders.filter((o:any)=>o.status!=='CANCELLED').map((o:any)=><option key={o.id} value={o.id}>{(o.request_number||o.requestNumber)}</option>)}
            </Select>
          </div>
          <div className="grid grid-cols-2 md:grid-cols-3 gap-3">
            <div><label className="label">Specimen Type</label><Input value={cultureForm.specimenType} onChange={e=>setCultureForm({...cultureForm,specimenType:e.target.value})} placeholder="e.g. Blood, Urine, Wound Swab"/></div>
            <div><label className="label">Growth Status</label><Select value={cultureForm.growthStatus} onChange={e=>setCultureForm({...cultureForm,growthStatus:e.target.value})}>
              {['NO_GROWTH','GROWTH','CONTAMINATED'].map(g=><option key={g}>{g}</option>)}
            </Select></div>
            <div><label className="label">Organism Identified</label><Input value={cultureForm.organismIdentified} onChange={e=>setCultureForm({...cultureForm,organismIdentified:e.target.value})} placeholder="e.g. E. coli, S. aureus"/></div>
            <div><label className="label">Colony Count</label><Input value={cultureForm.colonyCount} onChange={e=>setCultureForm({...cultureForm,colonyCount:e.target.value})} placeholder="e.g. 10^5 CFU/mL"/></div>
            <div><label className="label">Gram Stain</label><Input value={cultureForm.gramStain} onChange={e=>setCultureForm({...cultureForm,gramStain:e.target.value})} placeholder="e.g. Gram-negative rods"/></div>
          </div>

          {cultureForm.growthStatus==='GROWTH'&&(
            <div>
              <p className="label mb-2">Antibiotic Sensitivity (C&S)</p>
              <div className="grid grid-cols-7 gap-1.5 text-xs font-semibold text-slate-500 mb-1 px-1"><span className="col-span-4">Antibiotic</span><span className="col-span-2">Result</span><span>MIC</span></div>
              {abxRows.map((a,i)=>(
                <div key={i} className="grid grid-cols-7 gap-1.5 mb-1.5">
                  <Select className="col-span-4" value={a.antibiotic} onChange={e=>setAbxRows(abxRows.map((x,xi)=>xi===i?{...x,antibiotic:e.target.value}:x))}>
                    {ANTIBIOTICS.map(ab=><option key={ab}>{ab}</option>)}
                  </Select>
                  <Select className="col-span-2" value={a.result} onChange={e=>setAbxRows(abxRows.map((x,xi)=>xi===i?{...x,result:e.target.value}:x))}>
                    {SENSITIVITY.map(s=><option key={s} className={s==='SENSITIVE'?'text-green-600':s==='RESISTANT'?'text-red-600':'text-amber-600'}>{s}</option>)}
                  </Select>
                  <Input value={a.mic} onChange={e=>setAbxRows(abxRows.map((x,xi)=>xi===i?{...x,mic:e.target.value}:x))} placeholder="MIC"/>
                  <button type="button" onClick={()=>setAbxRows(abxRows.filter((_,xi)=>xi!==i))} className="text-red-400 col-span-1">✕</button>
                </div>
              ))}
              <button type="button" onClick={()=>setAbxRows([...abxRows,{antibiotic:'Amoxicillin',result:'SENSITIVE',mic:''}])} className="btn-secondary text-xs">+ Add Antibiotic</button>
            </div>
          )}

          <div><label className="label">Final Report / Comments</label><textarea className="input" rows={3} value={cultureForm.finalReport} onChange={e=>setCultureForm({...cultureForm,finalReport:e.target.value})} placeholder="Final impressions and recommendations..."/></div>
          <div className="flex gap-3"><button type="submit" disabled={saving||!cultureForm.requestId} className="btn-primary flex-1">{saving?'Saving...':'Save Culture Report'}</button><button type="button" onClick={()=>setShowCulture(false)} className="btn-secondary">Cancel</button></div>
        </form>
      </SlidePanel>
    </Layout>
  );
}